import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram } = FiIcons;

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-etera-black py-10 px-6 md:px-12 lg:px-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Left: Copyright & Legal Links */}
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
          <div className="text-etera-sage text-xs tracking-[0.2em] font-light">
            © {currentYear} ÉTERA DRAGON HOUSE.
          </div>
          <div className="flex gap-6">
            <Link 
              to="/imprint" 
              className="text-etera-sage hover:text-etera-gold transition-colors duration-300 text-[10px] uppercase tracking-widest font-medium"
            >
              Aviso Legal
            </Link>
            <Link 
              to="/privacy" 
              className="text-etera-sage hover:text-etera-gold transition-colors duration-300 text-[10px] uppercase tracking-widest font-medium"
            >
              Privacidad
            </Link>
          </div>
        </div>

        {/* Right: Instagram Link */}
        <a 
          href="https://www.instagram.com/eteradragonhouse" 
          target="_blank" 
          rel="noopener noreferrer"
          className="group flex items-center gap-2 text-etera-sage hover:text-etera-gold transition-colors duration-300 text-xs tracking-[0.2em]"
        >
          <SafeIcon icon={FiInstagram} className="text-lg" />
          <span className="font-medium">@eteradragonhouse</span>
        </a>
      </div>
    </footer>
  );
}